"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconStoneFilled = function IconStoneFilled(_ref) {
  var className = _ref.className,
      color = _ref.color,
      size = _ref.size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    id: "icons",
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.9 43.63L8.05 33.2C8.00571 33.0772 8.00571 32.9428 8.05 32.82L12 26.07C12.0285 26.0238 12.0488 25.9731 12.06 25.92L15 12.21C15.009 12.1431 15.0336 12.0793 15.0718 12.0238C15.11 11.9682 15.1608 11.9223 15.22 11.89L22.46 7.36C22.5267 7.31819 22.6023 7.29272 22.6808 7.28567C22.7592 7.27862 22.8381 7.29019 22.9112 7.31943C22.9843 7.34866 23.0495 7.39475 23.1014 7.45393C23.1533 7.51311 23.1905 7.58372 23.21 7.66L28 25.9C28.0152 25.9692 28.0152 26.0408 28 26.11L25.07 43.58C25.0511 43.6966 24.9915 43.8028 24.9018 43.8796C24.8121 43.9565 24.6981 43.9992 24.58 44H11.38C11.2705 43.9994 11.1643 43.9629 11.0776 43.896C10.9908 43.8292 10.9285 43.7357 10.9 43.63Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M42 29.26L39.08 43.6C39.057 43.7129 38.9956 43.8144 38.9063 43.8873C38.817 43.9602 38.7053 44 38.59 44H27.59C27.5179 43.9995 27.4467 43.9834 27.3814 43.9528C27.3161 43.9222 27.2582 43.8778 27.2116 43.8227C27.1651 43.7676 27.131 43.7031 27.1117 43.6336C27.0925 43.5641 27.0885 43.4912 27.1 43.42L30 26.33L30.07 25.91L29.96 25.49L27.76 17.15C27.7367 17.0604 27.7387 16.9662 27.7658 16.8777C27.7929 16.7892 27.844 16.71 27.9135 16.6488C27.9829 16.5877 28.068 16.547 28.1592 16.5313C28.2504 16.5156 28.3441 16.5256 28.43 16.56L36.78 19.9C36.8579 19.9302 36.9265 19.9803 36.9791 20.0452C37.0318 20.1101 37.0665 20.1876 37.08 20.27L38 24.85C38.02 24.9486 38.0687 25.039 38.14 25.11L41.84 28.81C41.9014 28.8663 41.9481 28.9367 41.9759 29.0151C42.0038 29.0936 42.0121 29.1776 42 29.26Z",
    fill: color
  }));
};

IconStoneFilled.defaultProps = {
  color: 'black',
  size: 30
};
IconStoneFilled.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string
};
var _default = IconStoneFilled;
exports.default = _default;